<template>
  <router-view />
</template>

<style lang="less">
  /* 控制 Header 隐藏动画 */
  .hidden {
    position: fixed;
    top: -100px !important; /* 隐藏 Header 向上移出可视区 */
    transition: top 0.3s ease;
    z-index: 999;
    width: 100%;
  }
</style>
